import { useEffect, useRef } from "react";

import { cn } from "../lib/utils";

const CLIENT = "ca-pub-6994469319818383";
const SLOT = process.env.REACT_APP_ADSENSE_SLOT;

/**
 * One manual AdSense unit per page. Auto ads (enabled in the AdSense dashboard)
 * cover everything else, so no slot id means no empty box.
 */
function AdSlot({ className }) {
  const pushed = useRef(false);

  useEffect(() => {
    if (!SLOT || pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      // Ad blockers and offline previews should not break the page.
    }
  }, []);

  if (!SLOT) return null;

  return (
    <aside
      aria-label="Advertisement"
      className={cn("mx-auto w-full max-w-3xl px-4 py-8 text-center", className)}
    >
      <p className="mb-2 text-[10px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
        Advertisement
      </p>
      <ins
        className="adsbygoogle block"
        style={{ display: "block" }}
        data-ad-client={CLIENT}
        data-ad-slot={SLOT}
        data-full-width-responsive="true"
      />
    </aside>
  );
}

export default AdSlot;
